<template>
     <div class="mx-1 md:mx-0 flex flex-wrap">
          <slot/>
     </div>
</template>